<style scoped>
    .emptyBox{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .emptyImg{
        width: 5.07rem;
        height: 4.1rem;
        background: url("~assets/activityCenter.png") no-repeat center/cover;
        margin-top: 1.5rem;
        margin-bottom: .62rem;
        font-size: .3rem;
        color: #6F6F6F;
    }
    ul{
        padding: .24rem;
    }
    li{
        padding: .24rem;
        background: #fff;
        margin-bottom: .2rem;
    }
    .titleBox{
        display: flex;
        align-items: center;
        margin-bottom: .3rem;
    }
    .circular{
        min-width: .2rem;
        height: .2rem;
        background: #EEEEEE;
        border-radius: 50%;
        margin-right: .3rem;
    }
    .titleBox span{
        font-weight: bold;
        font-size: .36rem;
        color: #000;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
    .time{
        color: #737373;
        font-size: .3rem;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="活动中心"></topbar>
        <ul v-if="!emptyStatus">
            <li v-for="item in activeList" @click="to(`activityDetail?activeId=${item.activeId}`)">
                <div class="titleBox">
                    <div class="circular"></div>
                    <span>{{item.activeTheme}}</span>
                </div>
                <div class="time">{{item.activeTime}}</div>
            </li>
        </ul>
        <div class="emptyBox" v-if="emptyStatus">
            <div class="emptyImg"></div>
            <div class="emptyName">目前还没有活动哦~</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                companyId:localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
                activeList:[]
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            to(n) {
                this.$router.push(`/${n}`)
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getActiveList()
                    }
                }
            },
            async getActiveList() {
                let obj = {}
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                obj.companyId = this.companyId;
                let data = await getSources("/bear-scale/api/scaleActive/getActiveList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.activeList = [...this.activeList, ...data.activeList];
                    if (data.activeList.length == 0) {
                        this.emptyStatus = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }

                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.userId=localStorage.getItem('userId')
            this.getActiveList();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/activityCenter.vue?46a9b450